import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DownloadApkButton from './DownloadApkButton';
import './TopBar.css';

const topLinks = [
  'Debut', 'Messages', 'Heure du Systeme', '', 'Controle de Numeros', 'Numeros Gagnants', 'Resultats', 'Deconnexion'
];

const TopBar = () => {
  const navigate = useNavigate();
  const { company, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <img
          className="topbar-logo"
          src="/logo-cgl-transparent.png"
          alt="CGL Multi-services"
          onClick={() => navigate('/dashboard')}
          role="button"
          tabIndex={0}
        />
        <span className="topbar-lotto">
          {company ? company.name : 'CHL LOTTO'}
          {(company?.company_user?.username || company?.username) && (
            <span className="topbar-user">
              /({company.company_user?.username || company.username})
            </span>
          )}
        </span>
      </div>
      <div className="topbar-links">
        {topLinks.map((link, i) =>
          link === '' ? (
            <span key={i} className="topbar-sep"> | </span>
          ) : (
            <span key={i}>
              {i > 0 && topLinks[i - 1] !== '' && <span className="topbar-sep"> | </span>}
              {link === 'Deconnexion' ? (
                <span className="topbar-link" onClick={handleLogout}>{link}</span>
              ) : link === 'Controle de Numeros' ? (
                <span className="topbar-link" onClick={() => navigate('/controles/number-control')}>{link}</span>
              ) : (
                <span className="topbar-link topbar-link-disabled">{link}</span>
              )}
            </span>
          )
        )}
        <span className="topbar-sep"> | </span>
        <DownloadApkButton variant="link" />
      </div>
    </div>
  );
};

export default TopBar;
